<form [formGroup]="formGroup">
  <mat-stepper #stepper linear orientation="horizontal" labelPosition="bottom">
    <mat-step [stepControl]="selectedCourierControl">
      <ng-template matStepLabel>
        <div class="main-step-label">Välj ombud</div>
        <div class="sub-step-label">{{selectedCourierControl.value?.name}}</div>
      </ng-template>

      <div class="step-content">
        <mat-button-toggle-group
          [formControl]="selectedCourierControl"
          [hideSingleSelectionIndicator]="true"
          [vertical]="true">
          @for(courier of couriers(); track $index) {
          <mat-button-toggle [value]="courier" [disabled]="!courier.enabled">
            {{courier.name}}
          </mat-button-toggle>
          }
        </mat-button-toggle-group>
      </div>
    </mat-step>

    <mat-step [stepControl]="selectedWeightControl">
      <ng-template matStepLabel>
        <div class="main-step-label">Välj maxvikt</div>
        <div class="sub-step-label">
          @if(selectedWeightControl.value != null) {
          {{selectedWeightControl.value}} kg
          }
        </div>
      </ng-template>

      <div class="step-content">
        <mat-button-toggle-group
          [formControl]="selectedWeightControl"
          [hideSingleSelectionIndicator]="true"
          [vertical]="true">
          @for(weight of selectedCourierControl.value?.weights; track $index) {
          <mat-button-toggle [value]="weight">{{weight}}kg</mat-button-toggle>
          }
        </mat-button-toggle-group>
      </div>
    </mat-step>

    <mat-step>
      <ng-template matStepLabel>
        <div class="main-step-label">Godkänn</div>
      </ng-template>

      <div class="step-content">
        <div class="buttons-container">
          <button mat-flat-button (click)="onBookShipment()">Boka retur</button>
          <button mat-stroked-button (click)="onCancel()">Avbryt</button>
        </div>
      </div>
    </mat-step>
  </mat-stepper>
</form>
